const apiClient = require('@/api/client.js')

export default {

    
    setJobStopActionStatus(job_stop_id, job_stop_action_id, is_active, callback) {
        
        apiClient.put('/job/stop/action/status', {
          job_stop_id: job_stop_id,
          job_stop_action_id: job_stop_action_id,
          is_active: is_active,
        }).then(function(response) {
            const err = response.err;
            if (response) {
                if (err) {
                return callback(new Error(response.error))
                }
            }
            
            return callback(null, response)
        })
    }

}


// WEBPACK FOOTER //
// ./src/components/job/stop-action/service.js